
import React from 'react'
import { Breadcrumb } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import _ from 'lodash'
import convertCamelCase from '../../../../../helpers/convert-camel-case'
class contentBreadcrum extends React.Component {
    navigateTo(path) {
        dispatch.content.showLandingPage(true);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        dispatch.content.openResourcePane(null);
        dispatch.lifeCycle.activePage('');
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct${path}`
        });
        dispatch.content.showAddContentBreadCrum(false);
    }

    contentListView() {
        const history = this.props.history;
        if (this.props.contentStatus === 'knowledgeBank') {
            history.push({
                pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/knowledgeBank`
            });
            dispatch.content.showAddContentBreadCrum(false);
            dispatch.content.getAllContentsByBaseCategory({ organizationId: this.props.match.params.workspaceId });
        }
        else {
            history.push({
                pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct`
            });
            dispatch.content.showAddContentBreadCrum(false);
            let userid = this.props.user._id.toString();
            let payload = {};
            payload.organizationId = this.props.selectedOrganisation.id;
            payload.userid = userid;
            dispatch.content.getAllContents(payload);

        }

    }
    render() {
        let allCategories = _.unionBy(this.props.categoryTree, this.props.categoryPublicTree, "_id");
        let bc = allCategories.filter((b, i) => { return b._id === this.props.routeParams.baseCategory })[0]
        let cat = bc && bc._id && bc.nodes && bc.nodes.filter((c, i) => { return c._id === this.props.routeParams.category })[0]
        let sub = cat && cat._id && cat.nodes && cat.nodes.filter((sc, i) => { return sc._id === this.props.routeParams.subCategory })[0]


        let stringStatus = this.props.routeParams.status === "in_development" ? "In Design" :
            this.props.routeParams.status === 'under_review' ? "Review request" :
                this.props.routeParams.status === 'forreview' ? "Received" :
                    this.props.routeParams.status === 'reviewRequest' ? "Sent" :
                        this.props.routeParams.status === 'published' ? "Published" :
                            this.props.routeParams.status ==="approved" ? "Approved":
                            this.props.routeParams.status

        let setStatus = []

        let pushStatus = this.props.routeParams.status === "knowledgeBank" ||
            this.props.routeParams.status === "publicKnowledgeBank" ||
            this.props.routeParams.status === "contentLibrary" ?
            null : this.props.match.params && this.props.match.params.status && setStatus.push({ bcItem: stringStatus, path:this.props.routeParams.status })
        if (this.props.routeParams.subCategory) {
            pushStatus;
            if (sub && sub.length !== 0) {
                setStatus.push({ bcItem: bc.name ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}`})
                setStatus.push({ bcItem: cat.name ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}/${this.props.routeParams.category}`})
                setStatus.push({ bcItem: sub.name ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}/${this.props.routeParams.category}/${this.props.routeParams.subCategory}`})
            }
        } else if (this.props.routeParams.category) {
            pushStatus;
            if (cat && cat.length !== 0) {
                setStatus.push({ bcItem: bc.name ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}`})
                setStatus.push({ bcItem: cat.name ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}/${this.props.routeParams.category}`})
            }
        } else if (this.props.routeParams.baseCategory) {
            pushStatus;
            if (bc && bc.length !== 0) {
                setStatus.push({ bcItem: bc.name ,path:`${this.props.routeParams.status}/${this.props.routeParams.baseCategory}`})
            }
        } else {
            pushStatus
        }



        let status = setStatus && setStatus.length !== 0 && setStatus.filter((item, i) => { return item.bcItem !== 'knowledgeBank' }).map((item, i) => {
            return item.bcItem ? <span key={i}>
                <Breadcrumb.Divider icon='right angle' />
                <Breadcrumb.Section onClick={()=>{this.navigateTo(`/status/${item.path}`)}}>
                    <EllipsisTooltip
                        name={item.bcItem}
                        position="bottom left"
                    />
                </Breadcrumb.Section>
            </span> : null
        })
        let cStatus = this.props.match.params.status
        return (

            <Breadcrumb className="breadCrumbs w_100" >

                {cStatus && cStatus !== 'knowledgeBank' && cStatus !== 'publicKnowledgeBank' ?
                    <Breadcrumb.Section onClick={()=>{this.navigateTo("")}}>Content Development Library</Breadcrumb.Section> :
                    cStatus === 'knowledgeBank' ?
                        <Breadcrumb.Section onClick={()=>{this.navigateTo("/status/knowledgeBank")}}>Workspace Library</Breadcrumb.Section>
                        : cStatus === 'publicKnowledgeBank' ?
                            <Breadcrumb.Section onClick={()=>{this.navigateTo("/status/publicKnowledgeBank")}}>Public Library</Breadcrumb.Section> :
                            <Breadcrumb.Section>Content Development Library</Breadcrumb.Section>
                }

                {/* // {cStatus ?
                // cStatus !== 'knowledgeBank' && cStatus !== 'publicKnowledgeBank'
                //     cStatus === 'contentLibrary' ?
                //         <Breadcrumb.Section >Content Development Library</Breadcrumb.Section> :
                //         cStatus === 'knowledgeBank' ?
                //             <Breadcrumb.Section >Workspace Library</Breadcrumb.Section>
                //             : cStatus === 'publicKnowledgeBank' ?
                //                 <Breadcrumb.Section >Public Library</Breadcrumb.Section> :
                //                 <Breadcrumb.Section >---</Breadcrumb.Section>
                //     :
                //     <Breadcrumb.Section >Content Development Library</Breadcrumb.Section>} */}


                {status}

            </Breadcrumb>
        )
    }

}

export default contentBreadcrum